'use client'

import { useState } from 'react'

interface ReadMoreClientProps {
  text: string
}

// About-section body with a 4-line clamp that toggles to "Show less". The
// toggle is omitted for short descriptions (nothing to expand). Presentation
// only.
export function ReadMoreClient({ text }: ReadMoreClientProps) {
  const [expanded, setExpanded] = useState(false)
  // Heuristic: only offer the toggle when the text is long enough to clamp.
  const clampable = text.length > 280

  return (
    <div className="flex flex-col gap-3">
      <p className={`text-foreground/85 text-base whitespace-pre-wrap ${clampable && !expanded ? 'line-clamp-4' : ''}`}>
        {text}
      </p>
      {clampable && (
        <button
          type="button"
          onClick={() => setExpanded(v => !v)}
          className="text-primary self-start font-bold hover:underline"
        >
          {expanded ? 'Show less' : 'Read more'}
        </button>
      )}
    </div>
  )
}
